import ButtonUi from "@UI/ButtonUi";
import { getCookie } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import "./style.scss";

const Default = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = mainStore.getMainStore("modal");
        const cookieConsent = mainStore.getMainStore("cookieConsent");
        const { type } = modal;

        useEffect(() => {
            const cookieValue = getCookie("_rispromo_cookie");
            if (!cookieValue) mainStore.setMainStore("cookieConsent", true);
        }, []);

        const setCookie = (name, value, days) => {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = `expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        };

        const handleClickCookies = () => {
            let elem = document.getElementById("timer");
            elem.classList.remove("fixed_bottom");
            setCookie("_rispromo_cookie", "true", 365);
            mainStore.setMainStore("cookieConsent", false);
        };

        return !["ava-wheel", "fortune"].includes(type) && cookieConsent ? ( // не показывать куки пока крутятся колеса
            <div className="ab-3422 cookies">
                <div className="cookies__main">
                    <div className="cookies__container">
                        <span className="cookies__title">
                            Мы используем{" "}
                            <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" className="cursor" rel="noreferrer">
                                cookies
                            </a>
                        </span>
                    </div>

                    <ButtonUi onClick={handleClickCookies} label="Ок" className={`cookies__btn`} />
                </div>
            </div>
        ) : null;
    }),
);

export default Default;
